

const  AdsBannerHelper = () => {
  return [
    {
    productId: 24568967616864,
    productRef: 2562011630040,
    type: 'Buy',
    title: "Touch Classic Centre Table",
    shortDescription: "Great Look, Natural Texture, Highly Durable.",
    productName: "Touch Classic Centre Table",
    imageURL: '../../Households/CentreTable/PeterFrankUyo/pics1.jpg',
    imgUrl1: '../../Households/CentreTable/PeterFrankUyo/pics1.jpg',
    imgUrl2: '../../Households/CentreTable/PeterFrankUyo/pics2.jpg',
    imgUrl3: '../../Households/CentreTable/PeterFrankUyo/pics3.jpg',
    imgUrl4:  '../../Households/CentreTable/PeterFrankUyo/pics4.jpg',
    imgUrl5: '../../Households/CentreTable/PeterFrankUyo/pics5.jpg',
    imgUrl6: '../../Households/CentreTable/PeterFrankUyo/pics6.jpg',
    imgUrl7: '../../Households/CentreTable/PeterFrankUyo/pics7.jpg',
    imgUrl8: '../../Households/CentreTable/PeterFrankUyo/pics8.jpg',
    imgUrl9: '../../Households/CentreTable/PeterFrankUyo/pics8.jpg',
    imgUrl10: '../../Households/CentreTable/PeterFrankUyo/pics8.jpg',
    videourl: '../../Households/CentreTable/PeterFrankUyo/CentreTablePeteFrankUyo.MP4',
    dummyUrl: '../../Households/CentreTable/PeterFrankUyo/pics3.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    shortDescription: 'Simple in style, smooth to feel, classic in every detail.',
    displayPrice: "45k Only - Now selling ",
    price: 45000,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Nwaniba Road',
    postedBy: 2785436,
    category: 'Center-Table',
    group: 'Shop and Listings',
    description: `
    Features:\n
     Simple in style, smooth to feel, classic in every detail. 
     This artistic piece brings warmth in every room. 
     It evokes the elements of comfy textures that agrees with beauty, finesse
     and that natural confident outlook.
    
    `,
    },
    {
    productId: 24568967384863,
    productRef: 256201163362,
    type: 'Buy',
    title: "Stylish Comfy Chair",
    shortDescription: "Stylish Look, Smooth Texture, Highly Durable.",
    productName: "Stylish Comfy Chair",
    imageURL: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics2.jpg',
    imgUrl1: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics1.jpg',
    imgUrl2: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics2.jpg',
    imgUrl3: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl4:  '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl5: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl6: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl7: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl8: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl9: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    imgUrl10: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics3.jpg',
    videourl: '../../Households/CentreTable/PeterFrankUyo/CentreTablePeteFrankUyo.MP4',
    dummyUrl: '../../Households/ComfortableChair/PeteFrank/AUGUST24-2026/pics2.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    shortDescription: 'Simple in style, smooth to feel, Durably built to last.',
    displayPrice: "200k Only - Now selling ",
    price: 200000,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Nwaniba Road',
    postedBy: 2785436,
    category: 'Comfortable-Chair',
    group: 'Shop and Listings',
    description: `
    Features:\n
     Simple in style, smooth to feel, classic in every detail. 
     This artistic comfortatble seat brings warmth in every room. 
     It evokes the elements of comfy textures that agrees with beauty, finesse
     and that stylish outlook.
    
    `,
    },
    {
      productId: 2456896741103,
      productRef: 2562011103,
      title: "ALLURING DINING SET",
      shortDescription: "100% durable Dining Set. Choose wide range inches for desired area.",
      imageURL: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      productName: 'ALLURING DINING SET',
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
      description: `
      Features:\n
     
      
      ✨ Key Features  
     
      `,
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      displayPrice: "250K",
      price: 250000,
      currency: ' ₦',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Uyo',
      state: 'Akwa-Ibom',
      areaName: 'Shelter Afrique',
      category: 'Dinning-Set',
      group: 'Shop and Listings',
    }
  ]
};


export default AdsBannerHelper;